export default __webpack_public_path__ + "static/media/ppi-vertical-blue-dark.0a34de3f.svg";